<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-6">
                                <label for="form_no">Form No. <span class="c-required">*</span></label>
                                <input type="text" v-model="search_data.form_no" v-validate="'required'" id="form_no" name="form_no"
                                       class="form-control form-control-sm" placeholder="Search by form no"
                                       />
                                <div class="invalid-feedback">Please enter form no.</div>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search()">
                            Search
                        </button>
                    </form>
                </b-card>

                <b-card>
                    <div v-if="ses.name" class="row mb-2">
                        <div class="col-md-10">
                            <p>
                                <span style="margin-left: 10px;font-size: 16px;"><strong>From No:</strong> {{ ses.form_no}}</span> |
                                <span style="margin-left: 10px;font-size: 16px;"><strong>Name:</strong> {{ ses.name}}</span> |
                                <span style="margin-left: 10px;font-size: 16px;"><strong>Father Name: </strong>{{ ses.father_husband_name}}</span> |
                                <span style="margin-left: 10px;font-size: 16px;"><strong>Village: </strong>{{ ses.village.desc}}</span> |
                                <span style="margin-left: 10px;font-size: 16px;"><strong>Mouza:</strong> {{ ses.mouza.desc}}</span>
                            </p>
                        </div>
                        <div v-if="ses.name" class="col-md-2 float-right">
                            <b-button
                                    v-b-modal.land-modal
                                    type="button"
                                    @click="$bvModal.show('land-modal'),  resetForm()"
                                    class="btn btn-success float-right btn-sm mb-1 text-black float-right"
                            >
                                Add Land
                                <i class="fas fa-plus"></i>
                            </b-button>
                        </div>
                    </div>
                    <div class="scrollable-table table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>land Type</th>
                                <th>Mouza</th>
                                <th>Plot No.</th>
                                <th>Khatian No</th>
                                <th>Total Land</th>
                                <th>Aquired Land</th>
                                <th>Land Ownership</th>
                                <th>LA Case</th>
                                <th>CCL Amount</th>
                                <th>Book/Sub Book</th>
                                <th>Cheque No.</th>
                                <th>Cheque Date</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(land, index) in lands.data" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ land.land_type.desc }}</td>
                                <td>{{ land.mouza.desc }}</td>
                                <td>{{ land.plot_no }}</td>
                                <td>{{ land.khatian_no }}</td>
                                <td>{{ land.total_land }}</td>
                                <td>{{ land.acquired_land }}</td>
                                <td>{{ land.land_ownership.desc }}</td>
                                <td><span v-if="land.la_case">{{ land.la_case.desc }}</span><span v-else></span></td>
                                <td>{{ land.ccl_amount }}</td>
                                <td>{{ land.book_no }}/{{ land.book_sub_no }}</td>
                                <td>{{ land.cheque_no }}</td>
                                <td>{{ land.cheque_date }}</td>
                                <td>
                                    <b-button
                                            variant="warning"
                                            class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                                            @click.prevent="getLand(land.id), $bvModal.show('land-modal')">
                                        <i class="far fa-edit"></i>
                                    </b-button>
                                    <b-button
                                            variant="danger"
                                            class="btn btn-warning btn-xs waves-effect waves-light"
                                            @click.prevent="softDelete(land.id)">
                                        <i class="far fa-trash-alt"></i>
                                    </b-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="!flag || lands.total === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <modal-create-land
                :land="land"
                :ses_id="ses.id"
                :cclShow="cclShow"
                :btn_edit="btn_edit"
                @cclShowUpdate="cclShowUpdate"
                @getPersonLands="search"
                @resetForm="resetForm"
        ></modal-create-land>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import ModalCreateLand from "../../../modals/ModalCreateLand";

    export default {
        page: {
            title: "List SES",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, ModalCreateLand},
        data() {
            return {
                title: "Search SES",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "SES",
                        active: true
                    }
                ],
                mouzas: [],
                land_types: [],
                land_ownerships: [],
                lands: [],
                land: {},
                ses: {},
                ses_id: '',
                search_data: {},
                flag: false,
                btn_edit: false,
                land_id: false,
                cclShow: false,
                show: false
            };
        },

        mounted() {

        },
        methods: {

            softDelete(landId) {
                http.delete("api/ses/lands/" + landId).then(response => {
                    if (!response.error) {
                        this.$bvToast.toast(response.data.message, {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                        this.search();
                    } else {
                        this.$bvToast.toast("Update Failed", {
                            title: "Error",
                            autoHideDelay: 5000,
                            variant: "danger"
                        });
                    }
                });
            },

            cclShowUpdate(value) {
                this.cclShow = value;
            },

            getLand(id) {
                this.btn_edit = true;
                http.get("api/ses/lands/" + id + "/edit").then(response => {
                    if (!response.data.error) {
                        this.land = response.data.land;
                        this.land.c_land_ownership_id != 1
                            ? (this.cclShow = true)
                            : (this.cclShow = false);
                    }
                });
            },

            resetForm() {
                this.btn_edit = false;
                this.land = {};
                this.land.ses_id = this.$route.params.ses_id;
            },

            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http.post("api/ses/land/search", this.search_data).then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.lands = response.data.lands;
                                this.ses = response.data.ses;
                            }
                        });
                    }
                });

            },

        },
    };
</script>
